import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Grid } from "../ecosystem";
import { LandingCard, PageHeading } from "../ecosystem/mybswh";

const ProfileLanding = (props) => {

    logUI("MBHWeb.UI.PersonalProfile.ComponentDidMount", new Date(), Tools.getURLPath());

    const onClickTile = (tileName, routeName) => {
        logUI(`MBHWeb.UI.PersonalProfileLanding.${tileName}.Clicked`, new Date(), Tools.getURLPath());
        if (routeName) {
            props.history.push(routeName);
        }
    };

    const headingText = "Personal Profile"

    const { isMyChartUser, disableMyChartMenuItems, isPrimaryUser, notPharmacyProxy } = Tools.handleMychartUserShowOrHideMenuItems();
    const { proxyName } = Tools.getProxyName();

    const landingItems = [
        {
            title: "Contact Information",
            body: "Let us know how to reach you and your emergency contacts.",
            to: "/demographics",
            show: notPharmacyProxy,
            disabled: (!isPrimaryUser && disableMyChartMenuItems),
            onClick: () => { onClickTile("ContactInformation"); }
        },
        {
            title: "Administrative Information",
            body: "View medical record ID information on file.",
            to: "/admininfo",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => { onClickTile("AdministrativeInformation"); }
        },
        {
            title: "Wallet Card",
            body: "Print a compact summary of your medical information.",
            to: "/walletcard",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => { onClickTile("WalletCard"); }
        },
        {
            title: "Advance Care Planning & Advance Directives",
            body: "Make your medical wishes known ahead of time.",
            to: "/directives",
            show: isMyChartUser,
            disabled: disableMyChartMenuItems,
            onClick: () => { onClickTile("AdvanceCareDirectivesPlanning"); }
        }
    ]

    return (
        <Grid className="body-content body-content--no-top-offset body-content--bg-gray personalprofile-landing-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading bodyOffset heading={headingText} proxyName={proxyName} />
                    <div className="row">
                        {
                            landingItems.map((item, i) => {
                                return item.show ? (
                                    <div className="col-12 col-lg-6">
                                        <LandingCard {...item} />
                                    </div>
                                ) : null
                            })
                        }
                    </div>
                </div>
            </div>
        </Grid>
    )
}

export default ProfileLanding
